import React from "react";
import "../CSS_folder/About.css";
import {
  Fade,
  Flip,
  Bounce,
  JackInTheBox,
  Rotate,
  Roll,
  Slide,
  Zoom,
} from "react-awesome-reveal";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import profile_pic from "../portfolio_pic.jpg";

function About() {
  return (
    <div id="about" className="AboutContainer">
      <div className="subAboutContainer">
        <div className="AboutImageContainer">
          <img className="AboutImage" src={profile_pic} />
        </div>

        <div className="AboutText">
          <Fade delay={700}>
            <h1>About Me</h1>
          </Fade>

          <Fade delay={900}>
            <p className="AboutTextP">
              I bring nearly 3 years of experience in both web and software
              development to the table. Collaborating within teams is where I
              thrive; I truly believe that the power of shared ideas leads to
              extraordinary outcomes. I'm passionate about using technology to
              solve challenges, always ready to provide innovative solutions
              that drive positive change.
            </p>
          </Fade>

          <Fade delay={1200}>
            <div className="Education">
              <h1>Education history</h1>
              <ul>
                <li>
                  Computer Programming @ Humber College | Jan 2022 - Aug 2023
                </li>
                <li>
                  Bachelor of Journalism and Communication @ The Hang Seng
                  University of Hong Kong | Sep 2016 - Jun 2020
                </li>
              </ul>

              <h1>Highlighted Employment history</h1>
              <ul>
                <li>
                  Web Developer/ Communication Officer @ Friends of the Earth
                  (Hong Kong) | Sep 2020 - Sep 2021
                </li>
              </ul>
            </div>
            <br></br>
          </Fade>

          <Fade delay={1700}>
          <b>#native_Cantonese_speaker&nbsp;&nbsp;&nbsp;</b>
          <b>#native_Mandarin_Speaker</b></Fade>
        </div>
      </div>
    </div>
  );
}

export default About;
